const zhAbout = {
  'hero.badge': '关于我们',
  'hero.title.line1': '专注娱乐真相',
  'hero.title.line2': '还原吃瓜现场',
  'hero.title.line3': '91黑料网',
  'hero.desc': '91在线吃瓜网成立于2023年，是国内领先的娱乐八卦资讯平台。我们致力于为广大吃瓜群众提供最真实、最快速、最全面的娱乐爆料内容。团队由资深娱记、互联网从业者和法律顾问组成，确保每一条爆料都经得起推敲。',
  'hero.btn1': '品牌信誉',
  'hero.btn2': '联系我们',
  'brand.badge': '权威信源',
  'brand.title': '品牌信誉与免责说明',
  'brand.desc': '本平台所有爆料内容均来源于公开网络渠道和知情人士投稿，我们坚持"有图有真相"的原则，对每一条信息进行多方交叉验证后方可发布。如涉及侵权或不实信息，请通过官方渠道联系我们，我们将在核实后第一时间处理。',
  'brand.btn': '查看隐私政策',
  'testimonial.badge': '用户口碑',
  'contact.badge': '联系我们',
  'contact.title': '商务合作与爆料投稿',
  'contact.cooperation': '商务合作',
  'contact.cooperationDesc': '广告投放、品牌合作、内容推广等商务洽谈',
  'contact.tip': '爆料投稿',
  'contact.tipDesc': '提供独家黑料、匿名投稿，严格保密',
  'contact.advertise': '广告洽谈',
  'contact.advertiseDesc': '广告位询价、定制营销方案',
  'contact.complaint': '侵权申诉',
  'contact.complaintDesc': '内容侵权投诉、法律事务处理',
  'cta.line1': '加入吃瓜前线',
  'cta.line2': '爆料有奖',
  'cta.line3': '商务直通',
  'cta.btn': '联系客服',
};

export default zhAbout;